var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSlots = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  overflow: "visible",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M11.26 18H4.48a.527.527 0 0 1-.527-.527c0-5.3 2.919-7.656 5.803-10.54l1.424-1.425a8 8 0 0 1-1.051.065c-1.484 0-2.765-.564-3.954-.564a2.3 2.3 0 0 0-2.297 2.296.527.527 0 0 1-.527.528H.527A.527.527 0 0 1 0 7.305V.527C0 .237.236 0 .527 0h2.825c.29 0 .527.236.527.527v.594C4.98.4 6.38 0 7.87 0c2.366 0 3.507 1.13 5.649 1.13.332 0 .602-.27.602-.603 0-.29.236-.527.527-.527h2.825c.29 0 .527.236.527.527 0 2.616-1.257 4.448-2.588 6.39-1.7 2.477-3.625 5.285-3.625 10.556a.527.527 0 0 1-.528.527"
})));
export default SvgSlots;